/**
 * PRD.330 §17 — where the Home "Collections Today" card goes.
 *
 * Users who can open Clinic Collection Details (same route rule as the guard
 * and nav: Billing at FULL) navigate to the report, which opens on its
 * default Today → Today Payment Date range — no extra route state needed.
 * Everyone else keeps the existing Collections drawer, so the card never
 * leads to a route they cannot open. The KPI calculation is NOT changed.
 */
import type { PermissionRequirement } from '@helios/authz';
import { isPathAccessible } from '../../auth/permissionMap';
import { CLINIC_COLLECTION_DETAILS_PATH } from '../reports/report-routes';

export type CollectionsCardTarget = { kind: 'navigate'; path: string } | { kind: 'drawer' };

export function collectionsCardTarget(
  can: (requirement: PermissionRequirement) => boolean,
): CollectionsCardTarget {
  return isPathAccessible(CLINIC_COLLECTION_DETAILS_PATH, can)
    ? { kind: 'navigate', path: CLINIC_COLLECTION_DETAILS_PATH }
    : { kind: 'drawer' };
}
